import PropTypes from "prop-types";
import React from "react";

const Thumb = (props) => {
	return (
		<div className={props.classes}>
			<img
				src={props.src}
				alt={props.alt}
				title={props.title}
				width="150"
				height="150"
			/>
		</div>
	);
};

Thumb.propTypes = {
	alt: PropTypes.string,
	title: PropTypes.string,
	classes: PropTypes.string,
	src: PropTypes.string.isRequired,
};

export default Thumb;
